import React, { ReactNode } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

interface Props {
  title: string;
  icon?: ReactNode;
  enable: () => void;
  disable: () => void;
  active: boolean;
  count: number;
  clickable: boolean;
  totalCount?: number;
}

export function QuickFilterOption({ title, icon, enable, disable, active, count, clickable, totalCount }: Props) {
  const rawPercentage = totalCount ? Math.round((count / totalCount) * 100) : 100;
  const percentage = rawPercentage === 0 ? "< 1" : rawPercentage;
  return (
    <div className="flex flex-row whitespace-nowrap items-start justify-between py-4 text-sm text-gray-600 cursor-default group">
      <div className="flex flex-1 flex-row w-1/3">
        {icon ?? null}
        <div className="truncate">{title}</div>
      </div>
      <div className="flex flex-row flex-none gap-2 items-center">
        {clickable && (
          <div className="text-xs cursor-pointer select-none">
            {active ? (
              <div className="rounded-full text-center bg-cool-gray-50 hover:bg-cool-gray-100 text-cool-gray-500 px-2 py-1 whitespace-nowrap" onClick={disable}>
                Clear
              </div>
            ) : (
              <div
                className="group-hover:visible invisible text-center rounded-full text-gray-800 bg-primary-light px-2 py-1 whitespace-nowrap"
                onClick={enable}
              >
                Filter
              </div>
            )}
          </div>
        )}
        {totalCount ? (
          <>
            <div></div>
            <div className="h-5 w-5">
              <CircularProgressbar
                value={(count / totalCount) * 100}
                styles={buildStyles({
                  strokeLinecap: "butt",
                  pathTransitionDuration: 0.5,

                  // Colors
                  pathColor: "#006BE6", // primary-main
                  trailColor: "rgb(209 213 219)", // gray-300
                })}
              />
            </div>
            <div className="text-xs mr-1">{percentage}%</div>
          </>
        ) : null}
        <div className="font-medium">{count}</div>
      </div>
    </div>
  );
}
